import { Box } from '@mui/material'
import Grid from '@mui/material/Grid2'
import React , {useState} from 'react'
import "animate.css";
import vamsisir from "../assets/DocImages/mahendra.jpeg"
import { Link } from 'react-router-dom';
import shape1 from '../assets/Images/shapes/SpecialitistThread-01.png'
import BookAppointmentDialog from './BookAnAppointmentDialogue'
import shwetamaam from "../assets/DocImages/Dr Swetha Kodali.jpg"
export default function HomeCaringDoctors () {
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  return (
    <div className='overflow-hidden'>
      <div className='max-w-[1340px] mx-auto px-[24px] md:px-[24px] xl:px-[0px]'>
        <div className='relative'>
          <div className='py-[64px] lg:py-[220px] px-[30px] lg:px-[80px] rounded-[24px] bg-[#c4e5e5]'>
            <Box>
              <Grid container
                spacing={2}
                sx={{
                  flexDirection: {
                    xs: "column-reverse", 
                    md: "column-reverse",
                    lg: "row", 
                  },
                }}
                className='flex items-center'>
                <Grid size={{ md: 12, lg: 6 }}>
                  <div className='flex flex-col gap-y-[28px] relative z-[1]  mt-10 xl:mt-0 animate__animated animate__fadeInUp '>
                    <div className='rounded-[24px] overflow-hidden max-w-full xl:max-w-[450px]'>
                      <img
                        src={shwetamaam}
                        alt='Check Patient - Medic X Webflow Template'
                        className='w-full object-cover'
                      />
                    </div>
                    <div className='rounded-[24px] overflow-hidden max-w-full xl:max-w-[450px]  ml-0 xl:ml-[17%]'>
                      <img
                        src={vamsisir}
                        alt='Hospital Chair - Medic X Webflow Template'
                        className='w-full h-full object-contain'
                      />
                    </div>
                  </div>
                </Grid>
                <Grid size={{ md: 12, lg: 6 }}>
                  <div className='max-w-full xl:max-w-[530px] pl-0 lg:pl-5 animate__animated animate__fadeInUp'>
                    <h2 className=' text-[36px] lg:text-[58px] leading-[1.138em] font-heading text-thickGreen  mb-[48px]'>
                    Meet our Expert Specialities
                    </h2>
                    <p className='text-[20px] font-[500] text-paraGreen leading-[1.667em] font-body mb-[40px]'>
                    Find the top doctors who are highly skilled and specialised in their respective fields dedicated to providing personalised treatment for your needs with optimal care and who will always guide you at every stage of your healthy journey.
                    </p>
                    <div className='sm:block md:flex md:space-x-4 space-y-4 md:space-y-0'>
                      <button
                         onClick={handleOpenDialog}
                        className='bg-orange text-white w-full md:w-[50%] px-6 py-6 rounded-full font-medium   font-body text-[20px] leading-[1.112em] 
             transition-all duration-300 hover:bg-lightGreen hover:bg-opacity-90 
             hover:translate-y-[-3px] block md:inline-block  text-center'
                      >
                        Book an Appointment
                      </button>

                      <Link
                        to='/about-us'
                        className='text-thickGreen hover:bg-orange font-body w-full md:w-[50%] px-6 py-6 rounded-full font-medium border border-lightGreen bg-transparent flex justify-center items-center hover:border-none hover:text-white text-[20px] leading-[1.112em]  transition-all duration-300 hover:translate-y-[-3px]'
                      >
                        About Us
                      </Link>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </div>
          <img
            src={shape1}
            loading='eager'
            alt='Caring Doctors Line Left Shape Bg - Medic X Webflow Template'
            className='absolute inline-block max-w-[46%] bottom-[0%]  xl:top-[15%] right-0 xl:left-[-19.5%]  animate__animated animate__fadeIn animate__delay-1s'
          />
        </div>
      </div>
      <BookAppointmentDialog open={dialogOpen} onClose={handleCloseDialog} />
    </div>
  )
}
